<template>
  <IconGoogle
    v-tooltip="props.mime"
    :name="computedIcon"
    :size="size"
    :color="color"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IconGoogle from '@/components/atomic/atoms/IconGoogle/IconGoogle.vue';

const props = defineProps({
  mime: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'var(--fontcolor)',
  },
  size: {
    type: String,
    default: '1.3rem',
  },
});

const mimeMap: Record<string, string> = {
  // PDF
  pdf: 'picture_as_pdf',
  'application/pdf': 'picture_as_pdf',

  // ZIP / Archive
  zip: 'folder_zip',
  'application/zip': 'folder_zip',
  rar: 'folder_zip',
  'application/vnd.rar': 'folder_zip',
  'application/x-rar': 'folder_zip',
  'application/x-rar-compressed': 'folder_zip',

  // Word
  doc: 'description',
  docx: 'description',
  'application/msword': 'description',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'description',

  // Excel
  csv: 'table_chart',
  xls: 'table_chart',
  xlsx: 'table_chart',
  'application/vnd.ms-excel': 'table_chart',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'table_chart',
  'text/csv': 'table_chart',

  // PowerPoint
  ppt: 'slideshow',
  pptx: 'slideshow',
  'application/vnd.ms-powerpoint': 'slideshow',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'slideshow',

  // Audio
  mp3: 'audio_file',
  mpeg: 'audio_file',
  'audio/mpeg': 'audio_file',
  'audio/mp3': 'audio_file',

  // Video
  mp4: 'video_file',
  'video/mp4': 'video_file',

  // Image
  jpeg: 'image',
  jpg: 'image',
  'image/jpeg': 'image',
  'image/jpg': 'image',
  'image/png': 'image',
  'image/gif': 'image',
  'image/webp': 'image',
  'image/bmp': 'image',
  'image/tiff': 'image',
}

const computedIcon = computed(() => {
  return mimeMap[props.mime.toLowerCase()] || 'insert_drive_file';
});
</script>
